import { HttpUtilService } from './../services/http-util.service';
import { CertificadoService } from './../services/certificado.service';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import DadosOutorganteModel from './../model/dados-outorgante.model';
import { MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { OutorgaService } from '../services/outorga.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-trocar-outorga',
  templateUrl: './trocar-outorga.component.html',
  styleUrls: ['./trocar-outorga.component.css']
})
export class TrocarOutorgaComponent implements OnInit {

  tiposDoc: Object[] = [
    { label: 'CNPJ', value: 1 },
    { label: 'CEI', value: 2 }
   
  ];
  documento;
  form: FormGroup;
  outorgado;
  mascara = '000.000.000-00';
  @Input() public dadosOutorgante: DadosOutorganteModel;

  subs: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<TrocarOutorgaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private certificadoService: CertificadoService,
    private outorgaService: OutorgaService,
    private httpUtilService: HttpUtilService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }


  ngOnInit() {
    this.createForm();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000,
    });
  }
  mascarar() {
    switch (this.tipoDocumento.value) {
      case 1:
        this.mascara = '00.000.000/0000-00';
        break;

      case 2:
        this.mascara = '00.000.00000/00';
        break;
      default:
        this.mascara = '000.000.000-00';
        break;
    }
  }
  private createForm() {
    this.form = this.fb.group(
      {
        inscricao: [],
        tipoDocumento: []
      },
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  async trocarOutorga() {
    const outorgante = this.tipoDocumento.value + this.inscricao.value.toString().padStart(14, 0);
    const { tpInscricao, inscricao } = this.httpUtilService.obterDadosCertificado();

    let outorgado;

    if (inscricao.toString().length == 15)
      outorgado = inscricao;
    else
      outorgado =  tpInscricao + inscricao.padStart(14, 0);
    
    const servicos = await this.certificadoService.consultaServicosOutorga(outorgante, outorgado);
    this.dadosOutorgante = await this.certificadoService.consultaDadosOutorgante(outorgante);

    if (this.existeDadosOutorgante()) {
      if (this.temServicos(servicos)) {
        this.outorgaService.changeOutorgado(outorgante, servicos, this.dadosOutorgante);
        this.onClose();
      }
    }
    this.router.navigate(['/home']);
  }

  private existeDadosOutorgante() {
    if (this.dadosOutorgante) {
      return true;
    }
    this.openSnackBar('Não foi localizado registro da inscrição informada', 'ERRO');
    return false;
  }

  private temServicos(servicos) {
    if (servicos) {

      servicos = servicos.filter(item => item.NU_SERVICO === 1);
      if (!servicos) {
        this.openSnackBar('Não foi localizada procuração outorgada/substabelecida de envio SEFIP para este usuário. Solicite à empresa a concessão de procuração eletrônica no Conectividade Social', 'AVISO');
        return false;
      }
      return true;

    } else {
      this.openSnackBar('Não foi localizada procuração outorgada/substabelecida de envio SEFIP para este usuário. Solicite à empresa a concessão de procuração eletrônica no Conectividade Social', 'AVISO');
      return false;
    }

  }
  get inscricao() {
    return this.form.get('inscricao');
  }

  get tipoDocumento() {
    return this.form.get('tipoDocumento');
  }
}
